import styled from 'styled-components';
import { motion } from 'framer-motion';
import { TERMS_AND_CONDITIONS } from '../../routes/routes';
import background from '../../assets/images/backoffice/auth-back.png';

export const Layout = styled(motion.div)`
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 100vh;
  justify-content: center;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background};
  padding: 40px 0;
`;

export const Main = styled.div<{ pathname: string }>`
  width: ${({ pathname }) =>
    pathname === TERMS_AND_CONDITIONS ? '1000px' : '500px'};
  margin: 30px auto;
  padding: 60px 40px;
  background: ${({ theme }) => theme.colors.neutral0};
  border-radius: 16px;
  box-shadow: ${({ theme }) => theme.shadows.shadowXS};
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-image: url(${background});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  @media (max-width: 1450px) {
    margin: 10px auto;
  }

  @media (max-width: 1000px) {
    max-width: calc(100% - 32px);
    padding: 16px;
  }
`;
